<div class="input-group date" :class="'input-group-' + inputSize">
    <input type="text" class="form-control" :id="id" :placeholder="placeholder" :value="value" readonly :disabled="disabled">
    <!--input-group-addon: workaround para que funcione con bootstrap 4-->
    <span class="input-group-append input-group-addon">
        <span class="input-group-text">
            <i class="mdi mdi-event mdi-lg"></i>
        </span>
    </span>
</div>